import { Calendar, X } from 'lucide-react'
import { toast } from 'react-hot-toast'
import { supabase } from '../../supabaseClient'
import { EVENT_COLORS } from '../../utils/dashboardConstants'

export default function AddEventModal({
  showAddEventModal, setShowAddEventModal,
  addEventForm, setAddEventForm,
  isSubmittingEvent, setIsSubmittingEvent,
  userInfo, fetchProductivityData
}) {
  if (!showAddEventModal) return null

  const handleSubmit = async () => {
    if (!addEventForm.title || !addEventForm.event_date) {
      toast.error("Judul dan Tanggal Wajib Diisi!")
      return
    }
    setIsSubmittingEvent(true)
    try {
      const { error } = await supabase
        .from('company_events')
        .insert([{
          title: addEventForm.title,
          event_date: addEventForm.event_date,
          description: addEventForm.description,
          color: addEventForm.color,
          created_by: userInfo.id
        }])

      if (error) throw error

      toast.success("Acara Perusahaan Berhasil Ditambahkan!")
      setShowAddEventModal(false)
      setAddEventForm({
        title: '',
        event_date: new Date().toISOString().split('T')[0],
        description: '',
        color: 'bg-teal-400'
      })

      fetchProductivityData()
    } catch (e) {
      toast.error("Gagal menyimpan acara: " + e.message)
    } finally {
      setIsSubmittingEvent(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-sm transition-opacity" onClick={() => setShowAddEventModal(false)} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden transform transition-all border border-gray-100/50">
        {/* Modal Header */}
        <div className="relative bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            <Calendar className="w-6 h-6 text-blue-100" />
            Tambah Acara Perusahaan
          </h3>
          <button
            onClick={() => setShowAddEventModal(false)}
            className="absolute right-4 top-4 text-white/70 hover:text-white transition-colors bg-white/10 hover:bg-white/20 p-1.5 rounded-lg"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="px-6 py-6 pb-24 overflow-y-auto max-h-[70vh]">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">Judul Acara *</label>
              <input
                type="text"
                value={addEventForm.title}
                onChange={(e) => setAddEventForm({ ...addEventForm, title: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-colors"
                placeholder="Contoh: Rapat Paripurna Tahunan"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">Deskripsi</label>
              <textarea
                value={addEventForm.description}
                onChange={(e) => setAddEventForm({ ...addEventForm, description: e.target.value })}
                rows={3}
                className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-colors resize-none"
                placeholder="Opsional: Keterangan tambahan mengenai acara ini"
              />
            </div>

            <div className="relative z-10">
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">Tanggal *</label>
              <input
                type="date"
                value={addEventForm.event_date}
                onChange={(e) => setAddEventForm({ ...addEventForm, event_date: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-colors"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">Warna Penanda</label>
              <div className="flex gap-3">
                {EVENT_COLORS.map(color => (
                  <button
                    key={color}
                    onClick={() => setAddEventForm({ ...addEventForm, color })}
                    className={`w-8 h-8 rounded-full ${color} cursor-pointer border-2 transition-all ${addEventForm.color === color ? 'border-gray-800 scale-110' : 'border-transparent hover:scale-105 hover:shadow-md'}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-6 py-4 border-t border-gray-100 flex items-center justify-end gap-3 rounded-b-2xl">
          <button
            onClick={() => setShowAddEventModal(false)}
            className="px-5 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-200 rounded-xl transition-colors"
          >
            Batal
          </button>
          <button
            disabled={isSubmittingEvent}
            onClick={handleSubmit}
            className={`px-6 py-2.5 text-sm font-semibold text-white rounded-xl shadow-md transition-all ${isSubmittingEvent
              ? 'bg-blue-400 cursor-not-allowed'
              : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 hover:shadow-lg hover:-translate-y-0.5'
              }`}
          >
            {isSubmittingEvent ? 'Menyimpan...' : 'Simpan Acara'}
          </button>
        </div>
      </div>
    </div>
  )
}
